$(document).ready(function (){
   // beause the container has not position relative so that the buttons are displayed wrong
  $('.container:has(div.news-slider)').css("position", "relative");
    const swiper = new window.Swiper('.news-slider', {
      slidesPerView: 1,
      autoplay: false,
      cssWidthAndHeight: true,
      spaceBetween: 20,
      a11y: {
        prevSlideMessage: 'Vorheriges Element',
        nextSlideMessage: 'Nächstes Element',
      },
      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        850: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
        1400: {
          slidesPerView: 3,
          spaceBetween: 90,
        },
      },

      // Optional parameters
      loop: true,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-news-next',
        prevEl: '.swiper-news-prev',
      },
    });
});
